import actions from "@/store/actions/casino/casinoAction";
import getters from "@/store/getters/casinoGetter";
import mutations from "@/store/mutations/casinoMutation";
/**
 * [GX] STRIPE
 */
export default {
  state: {
    tipsObj: {
      state: false,
      type: ''
    }
  },
  mutations,
  getters,
  actions
};
